export interface ActionLogUser {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
}

export interface ActionLog {
  user: ActionLogUser | null;
  created_at: string;
}

export class ActionLog {
  constructor(data: Partial<ActionLog> = {}) {
    Object.assign(this, data);
    this.user = data.user ?? null;
  }

  /**
   * Renvoie le nom de l'utilisateur à l'origine de l'action, ou son email à défaut.
   */
  get userName(): string {
    if (!this.user) return "";
    const name = [this.user.firstname, this.user.lastname].filter((e) => e).join(" ");
    return name || this.user.email || "";
  }
}

export interface ActionLogs {
  created: ActionLog | null;
  updated: ActionLog | null;
}

export class ActionLogs {
  constructor(data: Partial<ActionLogs> = {}) {
    this.created = data.created ? new ActionLog(data.created) : null;
    this.updated = data.updated ? new ActionLog(data.updated) : null;
  }
}
